<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>LATEST NEWS</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Latest News</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>

<!--<section>
    <div class="container">
        <div class="row" id="defaultnews" style=" color: white">
            <div class="col-md-12 mb-3" *ngFor="let item of news;">
                <div class="single-latest-item bg-primary p-3 border-radius-10">
                    <div class="single-latest-image"><a href="#"></a></div>
                    <div class="single-latest-text" style="color: black;">
                        &lt;!&ndash;  <img src="assets/img/hostel/news.gif" alt="" class="img img-thumbnail" style="width:100px">&ndash;&gt;
                        <h2><span>News</span></h2>
                        <h3><a href="#" class="text-secondary">{{ item?.title }}</a></h3>
                        <div class="single-item-comment-view text-white"><span><i
                            class="zmdi zmdi-calendar-check"></i>{{ item?.date }}</span>
                        </div>
                        <p class="text-white">{{ item?.description }}</p>
                        <p class="text-white cursor-pointer btn btn-outline-secondary" *ngIf="item?.file != null"
                           (click)="goTo(item?.file?.url)">Check Now </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>-->

<section class="bg-gray-50 py-10">
    <div class="container mx-auto px-6 lg:px-12">
        <header class="text-center mb-12">
            <h1 class="text-3xl font-bold text-gray-800 mb-4">Latest News</h1>
            <p class="text-gray-600 text-lg">Stay updated with the latest news and updates from the education world.</p>
        </header>
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10" id="defaultnews">
            <!-- Card -->
            <div class="bg-white shadow-lg rounded-xl overflow-hidden transform hover:scale-105 transition-transform" *ngFor="let item of news" style="margin: 10px">
                <div class="relative">
                    <div class="h-48 bg-cover bg-center" [ngStyle]="{'background-image': 'url(' + item?.image + ')'}"></div>
                    <span class="absolute top-4 left-4 bg-primary text-white text-xs font-semibold uppercase py-1 px-3 rounded-three-corner bg-secondary">News</span>
                </div>
                <div class="p-4">
                    <h3 class="text-lg font-bold bg-primary-light text-white py-2 px-3 rounded-md mb-3 text-wrap" >
                        <a href="#" class="hover:text-white transition-colors px-3 rounded" style="background: #f1f1f1">{{ item?.title }}</a>
                    </h3>
                    <div class="text-gray-600  max-h-20 overflow-hidden overflow-y-auto line-clamp-none" style="word-wrap: break-word;">
                        {{ item?.description }}
                    </div>
                    <div class="flex  text-sm text-gray-500 mb-3">
                        <span style="float: right"><i class="fa fa-calendar zmdi-calendar-check mr-2" style="margin-right: 10px;"></i>{{ item?.date }}</span>
                    </div>
                    <button
                        *ngIf="item?.file != null"
                        class="inline-block bg-secondary border-0 text-white text-sm font-medium px-5 py-2 rounded-md shadow hover:bg-primary-dark transition-colors"
                        (click)="goTo(item?.file?.url)"
                    >
                        Read More
                    </button>
                </div>
            </div>
        </div>
    </div>
</section>




